import { Link } from "react-router-dom";
import { BarChart3, FlaskConical, ArrowRight } from "lucide-react";
import Layout from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent } from "@/components/ui/card";

export default function Dashboard() {
  const { user } = useAuth();
  return (
    <Layout>
      <div className="mb-10">
        <p className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">
          Bem-vindo(a), {user?.name}
        </p>
        <h1 className="text-4xl sm:text-5xl font-heading font-extrabold tracking-tight text-slate-900 mt-2">
          Painel Sensorize STAT
        </h1>
        <p className="text-slate-600 mt-3 max-w-2xl">
          Ferramentas estatísticas para análise sensorial e de variância — projetadas
          para pesquisa, controle de qualidade e desenvolvimento de produtos.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-testid="dashboard-cards">
        <Link to="/anova" data-testid="card-anova" className="group">
          <Card className="border-slate-200 hover:shadow-md transition-shadow duration-200 hover:-translate-y-1 transform-gpu">
            <CardContent className="p-8">
              <div className="flex items-start justify-between">
                <div className="w-14 h-14 rounded-xl bg-[#FFF1E6] flex items-center justify-center">
                  <BarChart3 className="w-7 h-7 text-[#FF8A50]" />
                </div>
                <ArrowRight className="w-5 h-5 text-slate-400 group-hover:text-[#FF8A50] group-hover:translate-x-1 transition-transform" />
              </div>
              <h2 className="text-2xl font-heading font-bold text-slate-900 mt-6">Testes com ANOVA</h2>
              <p className="text-slate-600 mt-2">
                One-way ANOVA com Tukey e Dunnett, validação de premissas
                (Shapiro-Wilk, Levene) e exportação PDF/Excel.
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {["ADQ","PDO","Perfil Flash","Escala Hedônica","JAR","Aceitação","Intenção de Compra"].map(t => (
                  <span key={t} className="text-xs px-2 py-1 rounded-full bg-[#FFF1E6] text-[#E65C00] font-semibold">{t}</span>
                ))}
              </div>
            </CardContent>
          </Card>
        </Link>

        <Link to="/sensorial" data-testid="card-sensorial" className="group">
          <Card className="border-slate-200 hover:shadow-md transition-shadow duration-200 hover:-translate-y-1 transform-gpu">
            <CardContent className="p-8">
              <div className="flex items-start justify-between">
                <div className="w-14 h-14 rounded-xl bg-[#EEF7E4] flex items-center justify-center">
                  <FlaskConical className="w-7 h-7 text-[#7CB342]" />
                </div>
                <ArrowRight className="w-5 h-5 text-slate-400 group-hover:text-[#7CB342] group-hover:translate-x-1 transition-transform" />
              </div>
              <h2 className="text-2xl font-heading font-bold text-slate-900 mt-6">Testes de Escolha Forçada</h2>
              <p className="text-slate-600 mt-2">
                Testes de discriminação (Triangular, Tétrade, Duo-Trio, AFC…) com
                cálculo automático de tamanho amostral e IC de Wilson.
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {["Triangular","Tétrade","Duo-Trio","2-AFC","3-AFC","A/Não A"].map(t => (
                  <span key={t} className="text-xs px-2 py-1 rounded-full bg-[#EEF7E4] text-[#558B2F] font-semibold">{t}</span>
                ))}
              </div>
            </CardContent>
          </Card>
        </Link>
      </div>
    </Layout>
  );
}
